var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.classes,style:(_vm.dimensions),attrs:{"src":_vm.blank,"data-src":_vm.src},on:{"lazybeforeunveil":_vm.imgLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }